"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringTypeReducer = exports.stringCompare = exports.setQueryParam = exports.facetStateReducer = exports.facetInit = exports.dateCompare = exports.arrayTypeReducer = exports.FILTER_PARAMS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dates = require("../_utils/dates");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FILTER_PARAMS = {
  dateRange: {
    start: 'listingStartDate',
    end: 'listingEndDate'
  },
  language: 'listingLanguage',
  category: 'listingTopic',
  // topics in webinar
  categories: 'listingTopics',
  // topics in events + press release
  region: 'listingRegion'
};
exports.FILTER_PARAMS = FILTER_PARAMS;
var filterType = {
  listingStartDate: 'string',
  listingEndDate: 'string',
  listingLanguage: 'array',
  listingTopics: 'array',
  listingTopic: 'array',
  listingRegion: 'array'
};
var isBrowser = typeof window !== 'undefined';
var dateCompare = function dateCompare(a, b) {
  return new Date(a).valueOf() - new Date(b).valueOf();
};
exports.dateCompare = dateCompare;
var stringCompare = function stringCompare(a, b) {
  return a.toString().localeCompare(b.toString());
};
exports.stringCompare = stringCompare;
var stringTypeReducer = function stringTypeReducer(itemKey) {
  return function (accumulator, currentValue) {
    if (currentValue[itemKey]) accumulator[currentValue[itemKey]] = false;
    return accumulator;
  };
};
exports.stringTypeReducer = stringTypeReducer;
var arrayTypeReducer = function arrayTypeReducer(itemKey) {
  return function (accumulator, currentValue) {
    currentValue[itemKey].forEach(function (key) {
      if (key) accumulator[key] = false;
    });
    return accumulator;
  };
};
exports.arrayTypeReducer = arrayTypeReducer;
var facetStateReducer = function facetStateReducer(state, action) {
  var updatedState = _objectSpread({}, state);
  switch (action.type) {
    case 'checkbox':
      if (action.facet && state.checkbox[action.facet] && action.key) {
        updatedState.checkbox[action.facet][action.key] = action.boolean;
        return updatedState;
      }
      break;
    case 'checkboxAll':
      if (action.facet && state.checkbox[action.facet]) {
        Object.keys(state.checkbox[action.facet]).forEach(function (key) {
          if (action.facet) state.checkbox[action.facet][key] = action.boolean;
        });
        return updatedState;
      }
      break;
    case 'daterange':
      if (updatedState.dateRange && action.key) {
        updatedState.dateRange[action.key] = action.date;
        return updatedState;
      }
      break;
  }
  return state;
};
exports.facetStateReducer = facetStateReducer;
var setFacets = function setFacets(facetState, type, obj) {
  if (type && obj) {
    obj.forEach(function (value) {
      var foundItem = Object.keys(facetState.checkbox[type]).find(function (key) {
        return key.toLowerCase() === value.toLowerCase();
      });
      if (foundItem) {
        facetState.checkbox[type][foundItem] = true;
      }
    });
  }
};
var facetInit = function facetInit(listItems, dateRangeFacet, checkboxFacets) {
  var facetState = {
    dateRange: {
      start: dateRangeFacet.start.initial ? new Date(dateRangeFacet.start.initial) : null,
      end: dateRangeFacet.end.initial ? new Date(dateRangeFacet.end.initial) : null
    },
    checkbox: {}
  };
  checkboxFacets.forEach(function (facet) {
    switch (facet.itemType) {
      case 'string':
        facetState.checkbox[facet.itemKey] = listItems === null || listItems === void 0 ? void 0 : listItems.reduce(stringTypeReducer(facet.itemKey), {});
        break;
      case 'array':
        facetState.checkbox[facet.itemKey] = listItems === null || listItems === void 0 ? void 0 : listItems.reduce(arrayTypeReducer(facet.itemKey), {});
        break;
    }
  });

  // get query params from URL & apply to state (topic / language / date)
  var searchURL = isBrowser ? window.location.search : '';
  var searchParams = new URLSearchParams(searchURL);
  searchParams.forEach(function (value, key) {
    switch (key) {
      case FILTER_PARAMS.category:
        // topics in webinar
        setFacets(facetState, 'category', value.split(','));
        break;
      case FILTER_PARAMS.categories:
        // topics in events + press release
        setFacets(facetState, 'categories', value.split(','));
        break;
      case FILTER_PARAMS.language:
        setFacets(facetState, 'language', value.split(','));
        break;
      case FILTER_PARAMS.region:
        setFacets(facetState, 'region', value.split(','));
        break;
      case FILTER_PARAMS.dateRange.start:
        facetState.dateRange['start'] = (0, _dates.removeTimeAndTimezone)(value);
        break;
      case FILTER_PARAMS.dateRange.end:
        facetState.dateRange['end'] = (0, _dates.removeTimeAndTimezone)(value);
        break;
    }
  });
  return facetState;
};

// Change URLSearchParams from specific key (category / language)
exports.facetInit = facetInit;
var formatArrayQueryParameters = function formatArrayQueryParameters(searchParams, key, value, type) {
  var _searchParams$get;
  var currentValues = ((_searchParams$get = searchParams.get(key)) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.split(',')) || [];
  if (!currentValues && type === 'add') searchParams.set(key, '');
  switch (type) {
    case 'add':
      currentValues.push(value);
      searchParams.set(key, currentValues.join(','));
      break;
    case 'remove':
      var result = currentValues === null || currentValues === void 0 ? void 0 : currentValues.filter(function (val) {
        return val.toLowerCase() !== value.toLowerCase();
      });
      if (result.length > 0) {
        searchParams.set(key, result.join(','));
      } else {
        searchParams.delete(key);
      }
      break;
    case 'removeAll':
      searchParams.delete(key);
      break;
  }
};
var setQueryParam = function setQueryParam(key) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';
  var value = arguments.length > 2 ? arguments[2] : undefined;
  var searchURL = isBrowser ? window.location.search : '';
  var searchParams = new URLSearchParams(searchURL);
  var currentValue = value || '';
  switch (filterType[key]) {
    // topics & language is an array
    case 'array':
      // Action (add / remove / removeAll) in element (value) from array in specific key (category / language)
      formatArrayQueryParameters(searchParams, key, currentValue, type);
      break;
    // date range is string
    case 'string':
      if (type === 'add') {
        searchParams.set(key, currentValue);
      } else {
        searchParams.delete(key);
      }
      break;
  }
  if (isBrowser) {
    var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
    window.history.pushState({
      path: newurl
    }, '', newurl);
  }
};
exports.setQueryParam = setQueryParam;